import { useEffect, useState } from 'react';
import { GRID_LIMIT } from 'flow/utils/meeting-constants';
import {
    selectActiveMeetingMembers,
    selectSenderName,
    selectFullscreenOrNarrowWindow,
    selectActiveMeetingIsNarrowWindow,
    selectActiveMeetingViewIsThumbnail,
} from 'flow/selectors/meeting-selectors';
import { selectVideoShowSenderInGridStatus } from 'flow/selectors/video-selectors';
import { useAppSelector } from './useRedux';

export const useVideoGrid = () => {
    const isFullscreenOrNarrow = useAppSelector(selectFullscreenOrNarrowWindow);
    const isNarrowWindow = useAppSelector(selectActiveMeetingIsNarrowWindow);
    const isThumbnailView = useAppSelector(selectActiveMeetingViewIsThumbnail);
    const shouldShowSenderInGrid = useAppSelector(
        selectVideoShowSenderInGridStatus,
    );
    const ownName = useAppSelector(selectSenderName);
    const meetingMembers = useAppSelector(selectActiveMeetingMembers);

    const [numberOfMembersToRender, setNumberOfMembersToRender] = useState(0);

    // The minimized-members rail still needs the capped render count; tile
    // sizing itself is now owned by the measured-container layout engine.
    useEffect(() => {
        const totNumberOfMembers = meetingMembers?.valueSeq()?.size || 0;
        const foundMe = meetingMembers
            .valueSeq()
            .find((member) => member?.get('displayName') === ownName);
        const numberOfMembers =
            foundMe && !shouldShowSenderInGrid
                ? totNumberOfMembers - 1
                : totNumberOfMembers;
        const maxNumberOfSlots = shouldShowSenderInGrid
            ? GRID_LIMIT + 1
            : GRID_LIMIT;
        setNumberOfMembersToRender(Math.min(numberOfMembers, maxNumberOfSlots));
    }, [meetingMembers, shouldShowSenderInGrid, ownName]);

    return {
        numberOfMembersToRender,
        isFullscreenOrNarrow,
        isNarrowWindow,
        isThumbnailView,
        shouldShowSenderInGrid,
        ownName,
        meetingMembers,
    };
};
